import { render } from "./SignUpReportCustomerModal.vue?vue&type=template&id=2373b805&ts=true"
import script from "./SignUpReportCustomerModal.vue?vue&type=script&lang=ts"
export * from "./SignUpReportCustomerModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__